<template>
  <div 
    class="appeal-container"
  >
    <div 
      class="detail-box columns is-multiline is-centered is-12"
    >
      <div class="column is-9">
        <div
          class="violation-address"
        >
          Property Address
        </div> 
        <div class="appeal-address">
        {{ this.$store.state.detailPage.address }} 
        </div>
        <div class="appeal-opa-number has-text-weight-semibold">
          OPA number: {{ this.$store.state.detailPage.opa_account_num }}
        </div>
      </div>
      <div class="column is-3">
          <div class="violation-date has-text-weight-semibold"> </div>
          <div class="bottom-right-link print-hide">
            <a
              target="_blank"
              :href="'/property-history/search?address='+ this.$store.state.detailPage.address"
            >
              View property history and current owner information <i class="fa fa-external-link" aria-hidden="true"></i>
            </a>
          </div>
        </div>
    </div>

    <div 
      class="detail-table-container columns is-multiline is-centered is-12"
    >
      <div  class="appeal-detail-table no-header column is-8">
        <v-client-table 
          class="table-light no-header"
          :data="tableData" 
          :columns="columns" 
          :options="options"
        >
        </v-client-table>
        <h1>Hearing date and time</h1>
        <div class="hearing-time-container">
          <i class="fas fa-calendar-alt fa-2x"></i>
          <div class="hearing-time">
            {{  formatDate(detailInfo.date) }} <br>
            {{ detailInfo.time }}
          </div>
        </div>
      </div>
      <div class="map-surrounder column is-4">
        <div
          id="map"
          class="map map-class"
        >
          <ImageryToggleControl @toggleImagery="toggleImagery">
          </ImageryToggleControl>
        </div>
      </div>
    </div>
    <div
      class="docs-link"
      v-if="this.$store.state.appealsCalendar.zba"
    >
      <a
        :href="'https://redevelopmentauthority.quickbase.com/db/bsp2by6kc?a=API_GenAddRecordForm&_fid_38='+ this.$store.state.detailPage.meetingnumber +'&ifv=1'"
        target="_blank"
        class="button docs-button"
      >Submit documents for hearing</a>
      <a
        v-if="showAcceptedDocuments"
        :href="'https://redevelopmentauthority.quickbase.com/nav/app/bsp2bacci/table/btirm3844/action/dr?key='+ this.$store.state.detailPage.meetingnumber"
        target="_blank"
        class="button docs-button"
      >View accepted documents</a>
    </div>
    <div>
      <span v-if="this.$store.state.appealsCalendar.zba">
      <h1>Appeal description</h1>
      {{detailInfo.appealgrounds}}
      </span>
        <v-client-table 
          class="results-table appeal-detail full-screen-static"
          :data="decisionHistoryTable" 
          :columns="decisionColumns"
          :options="decisionOptions"
        >
          <div slot="beforeTable" class="appeal-label">
            <h1>Hearing results</h1>
          </div>
          <div 
            slot="afterTable"
            class="has-text-centered"
            v-if="!decisionHistoryTable"
          >
           <h1> No hearing results.</h1>
          </div>
        </v-client-table>
        <v-client-table 
          class="results-table appeal-detail full-screen-static"
          :data="courtHistoryTable" 
          :columns="courtColumns" 
          :options="courtOptions"
        >
          <div slot="beforeTable" class="appeal-label">
            <h1>Court History</h1>
          </div>
          <div 
            slot="afterTable"
            class="has-text-centered"
            v-if="!courtHistoryTable"
          >
           <h1> No court history.</h1>
          </div>
        </v-client-table>
          <div class="callout">
            <!-- <div class="callout-image-div"><i class="fa fa-exclamation-triangle fa-3x" /></div> -->
            <div class="callout-text-div">
              This information is presented for reference purposes only and should not be used in place of legal advice. 
            </div>
          </div>
    </div>
  </div>
</template>

<script>

import maplibregl from 'maplibre-gl';
import 'maplibre-gl/dist/maplibre-gl.css';

import moment from 'moment-timezone';
import ImageryToggleControl from '../../components/ImageryToggleControl.vue';

export default {
  name: 'appeal',
  components: {
    ImageryToggleControl,
  },
  // props: {
  //   ready: null,
  // },
  data() {
    return { 
      columns: ['id', 'name'],
      courtHistoryTable: [],
      decisionHistoryTable: [],
      courtColumns: ['date', 'court', 'courtcasenumber', 'courtaction', 'courtresult', 'courtproviso' ],
      decisionColumns: ['date','decision','meetingremarks'],
      detailInfo: this.$store.state.detailPage,
      localLocation: null,
      decisionOptions: {
        filterable: false,
        sortable: [],
        pagination: { 
          show: false, 
          virtual: false,
        },
        headings: { 
          date: "Date", 
          decision: "Result",
          meetingremarks: "Notes",
        },
      },
      courtOptions: {
        filterable: false,
        sortable: [],
        pagination: { 
          show: false, 
          virtual: false,
        },
        headings: { 
          date:"Date", 
          court: "Court type", 
          courtcasenumber: "Case number", 
          courtaction: "Action", 
          courtresult: "Results", 
          courtproviso:  "Meeting remarks"
        },
      },
      options: {
        filterable: false,
        highlightMatches: false,
        pagination: { 
          show: false, 
          virtual: false,
        },
        perPage: 100,
        columnsClasses: {
          id: 'violations table-id has-text-weight-bold',
          name: 'table-name',
        },
      },
    }
  },
  created(){
    console.log('created')
    this.tableSetup();
  },
  mounted() {
    this.calculateCenter();
    const map = new maplibregl.Map({
      container: 'map',
      style: this.$config.map.mbStyle,
      center: this.$store.state.map.center,
      zoom: this.$store.state.map.zoom,
      minZoom: 6,
      maxZoom: 22,
      attributionControl: false,
    });

    map.on('load', () => {
      this.$store.state.map.map = map;
      let canvas = document.querySelector(".maplibregl-canvas");
      canvas.setAttribute('tabindex', -1);
      let marker = new maplibregl.Marker({
        color: '#2176d2',
      }).setLngLat(this.$store.state.map.center)
        .addTo(map);
      // map.getSource('liBuildingFootprints').setData(geojson);
    })
  },
  destroyed(){
    // this.$emit('closeDetail');
    this.$store.commit('closeDetail');
  },  
    watch: {
    '$route.query': function(newVal, oldVal) {
      console.log('$route.query: newVal', newVal, 'oldVal: ', oldVal );
      if(newVal.query && !oldVal.query) {
        this.tableSetup();
      }
    },
  },
  computed: {
    tableData(){
      let tableInfo = [
          { id: "Appeal number", 
            name: this.detailInfo.appealnumber
          },
          { id: "Appeal Type", 
            name: this.detailInfo.appealtype
          },
          { id: "Application Type", 
            name: this.detailInfo.applicationtype
          },
          { id: "Primary applicant", 
            name: this.detailInfo.primaryappellant
          },
          { id: "Meeting ID",
            name: this.detailInfo.meetingnumber
          },
          { id: "Decision date",
            name: this.detailInfo.decisiondate ? this.formatDate(this.detailInfo.decisiondate) : "N/A"
          },
          { id: "Permit application number", 
            name: this.detailInfo.relatedpermit && this.detailInfo.relatedpermit.length > 0 ? this.detailInfo.relatedpermit : this.detailInfo.relatedcasefile
          },
          {
            id: "Coordinating RCO",
            name: this.detailInfo.coordinatingrco,
          }
      ]
      return tableInfo;
    },
    // the accepted-exhibits link stays up until 45 days after a final disposition
    // (Completed or Dismissed / Withdrawn); every other appeal shows it
    showAcceptedDocuments(){
      let appeal = this.$store.state.detailPage;
      let decisionDate = moment(appeal.decisiondate, moment.ISO_8601);
      let finalDispositionOver45Days = ['Completed', 'Dismissed / Withdrawn'].includes(appeal.appealstatus)
        && decisionDate.isValid()
        && decisionDate.isBefore(moment().subtract(45, 'days'), 'day');
      return !finalDispositionOver45Days;
    },
  },
  methods: {
    formatDate(value){
      console.log(value);
      // Date.parse(detailInfo.date).toString("MMMM yyyy")
      return moment(value).format('MMMM D, YYYY')

    },
    calculateCenter() {
      // Get Latitude and Longitude Array
      // console.log(this.detailInfo.latlng)
      const defaultCenter = [-75.163471, 39.953338];
      if (typeof this.detailInfo.latlng === "string") {
        let point = "";
        point = this.detailInfo.latlng.replace("POINT(", "");
        point = point.replace(")", "");
        let pointArr = point.split(" ");
        let lng = parseFloat(pointArr[0]);
        let lat = parseFloat(pointArr[1]);
        // an appeal with no address arrives as 'POINT EMPTY', which splits into two
        // non-numeric parts - the map can't center on NaN, so it gets the default
        if (pointArr.length === 2 && !isNaN(lng) && !isNaN(lat)) {
          // this.localLocation = [
          //   parseFloat(pointArr[1]),
          //   parseFloat(pointArr[0])
          // ];
          this.$store.commit('setMapCenter', [lng, lat]);
        } else {
          this.$store.commit('setMapCenter', defaultCenter);
        }
      } else {
        // this.localLocation = null;
        this.$store.commit('setMapCenter', defaultCenter);
      }
    },
    tableSetup(){
      console.log('decision history:', this.$store.state.appealsCalendar.decisionHistory);
      if (this.$store.state.appealsCalendar.decisionHistory && this.$store.state.appealsCalendar.decisionHistory.length > 0) {
        let table = this.$store.state.appealsCalendar.decisionHistory
        table.map(
          a => a.date = moment(a.decisiondate).format("M/D/yyyy")
        )
        this.$set( this, 'decisionHistoryTable', this.$store.state.appealsCalendar.decisionHistory);
        return
      }
      if (this.$store.state.appealsCalendar.courtHistory && this.$store.state.appealsCalendar.courtHistory.length > 0) {
        this.courtHistoryTable = this.$store.state.appealsCalendar.courtHistory;
        this.courtHistoryTable.map(
          a => a.date = moment(a.courtactiondate).format("M/D/yyyy")
        )
      return
      }
      return
    },
    toggleImagery() {
      const map = this.$store.state.map.map;
      if (!this.$store.state.map.imageryOn) {
        this.$store.state.map.imageryOn = true;
        map.addLayer(this.$config.map.mapLayers['2023']);
        map.addLayer(this.$config.map.mapLayers.imageryLabels);
        map.addLayer(this.$config.map.mapLayers.imageryParcelOutlines);
      } else {
        this.$store.state.map.imageryOn = false;
        map.removeLayer('2023');
        map.removeLayer('imageryLabels');
        map.removeLayer('imageryParcelOutlines')
      }
    },
    // calculateCenter() {
    //   this.$store.commit('setMapCenter', [-75.163471, 39.953338]);
    // },
  },
}
</script>

<style scoped>
  h1 {
    font-weight: 600;
    font-size: 16px;
    margin-bottom: 3px;
  }
</style>

<style lang="scss">

.docs-link {
  margin-top: 24px;
  margin-bottom: 24px;
}

.docs-button {
  background-color: #96c9ff;
  color: #000000 !important;
}

.docs-button + .docs-button {
  margin-left: 12px;
}

@media print {
    .appeal-detail {
      break-inside: avoid;
      overflow: visible;
    }
    .table-responsive {
      overflow: visible;
    }
  }

.violation-address {
  font-size: 18px;
  font-family: 'OpenSans-Regular', 'Open Sans', sans-serif;
  color:  #444444;
}

  .appeal-detail>div.table-responsive>table {
    margin-top: 3px !important;
  }

.appeal-address {
  font-size: 28px;
  padding-top: 4px;
  padding-bottom: 4px;
}

.appeal-opa-number {
  font-size: 12px;
}

.hearing-time-container {
  display: flex;
  .hearing-time {
    background: $light;
    padding: 3px 3px 3px 15px;
    display: inline-flex;
    float: right;
    align-items: center;
    width: 100%;
  }
  .fa-calendar-alt {
    padding: 15px;
    color: white;
    background-color: $grey-dark;
    margin-right: 7px;
    display: inline-flex;
  }
}

.detail-table-container.columns {
  padding-left: 0;
  padding-right: 0;
}
.map-container.column {
  padding-right: 0;
}
.appeal-detail-table {
  &.column {
    padding-left: 0;
  }
  .table-light {
    margin-bottom: 25px;
    padding-left: 0.75rem;
  }
}

.appeal-container {
  margin-top: 4rem;
  background-color: white;
  margin: auto;
  &.column {
    padding-left: 0;
    padding-right: 0;
  }
  .detail-box {
    background-color: $ben-franklin-blue-light;
    margin: 0;
    // padding: 15px 5px 15px 25px;
    clear: both;
    position: relative;
    // & .column {
    //   padding: 0;
    // }
    .license-title {
      text-transform: uppercase;
    }
    .license-number {
      text-transform: uppercase;
      padding: 5px 0 15px 0;
    }
    .bottom-right-link {
      right: 15px;
      bottom: 15px;
      font-size: 14px;
    }
    .violation-date {
      text-align: right;
     padding-right: 30px;
    }
  }
}

.has-text-centered>h1 {
  margin-bottom: 15px;
}

.columns:last-child {
   margin-bottom: 0;
}
.no-header th {
  display: none !important;
}

// End Violations Detail CSS
.table-id.has-text-weight-bold {
  width: 35%;
}

@media screen and (max-width: 768px) {
  .callout>.callout-image-div {
    display: inline-block;
    float: none;
  }
}

.callout-image-div {
  margin-right: 20px;
  // padding-top: 10px;
  float: left;
  height: 100px;
  width: 70px;
}

.callout-text-div {
  font-size: 13px;
  display: -webkit-box;
  text-align: left;
}

.button-control {
  margin-right: 10px !important;
  margin-left: 10px !important;
}

.maplibregl-ctrl {
  margin-left: 10px !important;
}

.map-class {
  height: 100%;
}


</style>